import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Caption } from "../Typography";
import { colorsDark } from "../../themes";

interface Props {
  caption?: string;
  containerFontColor?: string;
  useCustomDisplay?: JSX.Element;
}

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(2),
  },
  fontColor: (props: { containerFontColor?: string }) => ({
    color: props.containerFontColor || colorsDark.font.secondary,
  }),
}));

export default function EmptyDataContainer({ caption, containerFontColor, useCustomDisplay }: Props) {
  const classes = useStyles({ containerFontColor });
  return (
    <div>
      {useCustomDisplay ? (
        useCustomDisplay
      ) : (
        <div className={classes.container}>
          <Caption className={classes.fontColor}>{caption || "No results found"}</Caption>
        </div>
      )}
    </div>
  );
}
